export default function About() {
  return (
    <section id="about" data-testid="about-section" className="bg-[#FAF8F5] border-y border-[#E2DCD0]">
      <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-16 py-24 sm:py-32">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">
          <div className="lg:col-span-5">
            <div className="relative aspect-[4/5] rounded-3xl overflow-hidden">
              <img
                src="https://plus.unsplash.com/premium_photo-1661302937433-f10839c3f0f2?fm=jpg&q=80&w=1200&auto=format&fit=crop&ixlib=rb-4.1.0"
                alt="Compassionate connection"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="mt-6 border-l-2 border-[#C89F5D] pl-5 italic font-serif text-xl text-[#5C5856] leading-snug">
              “Born of family, raised in faith, built for the community we love.”
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="text-xs tracking-[0.22em] uppercase font-bold text-[#8B2635] mb-4">
              Our Story
            </div>
            <h2 className="font-serif text-4xl sm:text-5xl text-[#2C2A29] leading-[1.05] tracking-tight">
              A foundation rooted in <span className="italic text-[#692128]">love</span>, legacy, and the lives we carry forward.
            </h2>

            <div className="mt-8 space-y-5 text-[#5C5856] text-lg leading-relaxed">
              <p>
                Guardian Grace was inspired by the quiet strength of family — by parents
                who modeled love, grandmothers who prayed without ceasing, and sisters
                who served with everything they had.
              </p>
              <p>
                It is shaped by lived experience: caring for a child through sickle cell
                disease, walking alongside a loved one with lupus, advocating for a child
                living with ADHD, and honoring the service of a Navy veteran in our
                family. These stories are the heartbeat of every program we offer.
              </p>
              <p>
                We are a faith-grounded, community-centered nonprofit — partnered with
                Zion Full Gospel World Ministries and 1st Touch Enterprise Holdings — to
                meet families with both spiritual care and practical, day-to-day support.
              </p>
            </div>

            <div className="mt-10 grid grid-cols-2 sm:grid-cols-4 gap-6">
              {[
                { k: "Families", v: "Strengthened" },
                { k: "Caregivers", v: "Supported" },
                { k: "Veterans", v: "Honored" },
                { k: "Communities", v: "Uplifted" },
              ].map((s) => (
                <div key={s.k} className="border-t border-[#D5C9B3] pt-4">
                  <div className="font-serif text-2xl text-[#692128]">{s.k}</div>
                  <div className="text-sm text-[#5C5856] tracking-wide">{s.v}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
